import { HttpClient } from './HttpClient';
import { PredefinedAction } from '@/types/action';

interface FetchPredefinedActionsParams {
  category?: string;
  limit?: number;
}

export const PredefinedActionsService = {
  async fetchPredefinedActions(params?: FetchPredefinedActionsParams): Promise<{ data: PredefinedAction[] }> {
    const queryParams = new URLSearchParams();
    
    // Add optional parameters
    if (params?.category) {
      queryParams.append('category', params.category);
    }
    if (params?.limit) {
      queryParams.append('limit', params.limit.toString());
    }
    
    const response = await HttpClient.apiClient.get(`/actions/predefined?${queryParams.toString()}`);
    return response.data;
  },

  async fetchPredefinedActionById(actionId: string): Promise<{ data: PredefinedAction }> {
    const response = await HttpClient.apiClient.get(`/actions/predefined/${actionId}`);
    return response.data;
  },

  async enablePredefinedAction(actionId: string): Promise<{ status: string; message: string }> {
    const response = await HttpClient.apiClient.post(`/actions/predefined/${actionId}/enable`);
    return response.data;
  }
};